import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Curso from "../Curso/curso";
import Contact from "../Contact/contact";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import SlowMotionVideoIcon from "@mui/icons-material/SlowMotionVideo";
import School from "@mui/icons-material/School";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ImportantDevicesIcon from "@mui/icons-material/ImportantDevices";
import TagFacesIcon from "@mui/icons-material/TagFacesTwoTone";
import Typography from "@mui/material/Typography";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import LinearProgress from "@mui/material/LinearProgress";
import { obtenerCursos } from "../Services/cursosServices";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Skeleton from "@mui/material/Skeleton";
import { Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Review from "../Review/review";

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
    margin: "auto",
  },
});

const Start = () => {
  const [cursos, setCursos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cupon, setCupon] = useState("");
  const [cuponv, setCuponv] = useState(false);

  const history = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    cargarCursos();
  }, []);

  const cargarCursos = async () => {
    const { data: cursos } = await obtenerCursos();
    setCursos(cursos);
    setLoading(false);
    setCupon(cursos[0].cupon);
  };

  let hoy = new Date();

  const classes = useStyles();

  return (
    <>
      {loading && <LinearProgress />}
      <Container
        className="main-bg"
        maxWidth="sm xs lg"
        sx={{ backgroundColor: "white" }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} lg={6}>
            <div className="main-title">
              <h1>
                Aprende
                <br />
                Proyecta
                <br />
                Crea
              </h1>
              <h6>
                Descubre nuevas oportunidades con
                <br />
                nuestros cursos de programación.
                <br />
                <br />
                Diseñados para todos los niveles.
              </h6>
              <Button
                type="submit"
                variant="contained"
                color="success"
                size="large"
                sx={{ backgroundColor: "#27cd11" }}
                onClick={() => history("/cursos")}
              >
                llévame allí
              </Button>
            </div>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="sm xs lg" sx={{ backgroundColor: "white" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} lg={6}>
            <div className="main-title3">
              <Grid
                container
                spacing={5}
                sx={{
                  height: "100%",
                }}
                alignItems="flex-end"
                justifyContent="center"
              >
                <Grid item>
                  <img src="company/osde.png" width="200" />
                </Grid>
                <Grid item>
                  <img src="company/movistar.png" width="250" />
                </Grid>
                <Grid item>
                  <img src="company/bcp.png" width="200" />
                </Grid>

                <Grid item>
                  <img src="company/quilmes.png" width="250" />
                </Grid>
                <Grid item>
                  <img src="company/telefonica.png" width="250" />
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item sm>
            <div className="main-title2">
              <p className="text-main2">Empresas que ya nos han elegido</p>
              <p className="subtext-main2">
                Con Business Education Plan, importantes empresas <br />
                de todo el mundo nos eligen día a día, integrando conocimientos,
                flexibilidad y compromiso.
              </p>
            </div>
          </Grid>
        </Grid>
        <br />
        <br />
        <br />
        <br />
      </Container>
      <br />
      <br />

      <Container maxWidth="sm xs lg" sx={{ backgroundColor: "white" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} lg={6}>
            <div className="main-title3">
              <p className="text-main3">Potencia tus Ideas</p>
              <p className="subtext-main3">
                Nuestros cursos de programación abarcan
                <br />
                desde los fundamentos hasta las tecnologías más avanzadas.
                <br />
                <br />
                Descubre cómo ello, puede impulsar tu carrera.
              </p>
              <Button
                type="submit"
                variant="contained"
                color="success"
                size="large"
                sx={{ backgroundColor: "#27cd11" }}
                onClick={() => history("/cursos")}
              >
                ¡estoy preparado!
              </Button>
            </div>
          </Grid>
          <Grid item xs sm lg>
            <img src="images/main_bg10.jpg" width="80%" />
          </Grid>
        </Grid>
        <br />
        <br />
        <br />
        <br />
      </Container>
      <br />
      <br />
      <Container maxWidth="sm xs lg" sx={{ backgroundColor: "white" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} lg={6}>
            <img src="images/main_bg2.jpg" width="80%" />
          </Grid>
          <Grid item sm>
            <div className="main-title2">
              <p className="text-main2">¿Porqué Elegir Nuestros Cursos?</p>
              <p className="subtext-main2">
                Ofrecemos contenido actualizado, instructores expertos,
                <br />
                proyectos prácticos, flexibilidad horaria y una gran comunidad
                que te servirá de apoyo.
                <br />
                <br />
                Seas principiante o un experto en busca de actualizaciones,
                <br />
                tenemos el curso perfecto para tí.
              </p>
            </div>
          </Grid>
        </Grid>
      </Container>
      <br />
      <br />

      <Container maxWidth="sm xs lg" sx={{ backgroundColor: "white" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} lg={6}>
            <Box className="main-title3">
              <p className="text-main3">Historias de Éxito</p>
              <p className="subtext-main3">
                No tomes solo nuestra palabra.
                <br />
                Escucha lo que nuestros estudiantes tienen para decir.
                <br />
                <br />
                <br />
                <Review idUdemy="2069857" titulo={""}></Review>
              </p>
            </Box>
          </Grid>
          <Grid item sm>
            <img src="images/main_bg3.jpg" width="80%" />
          </Grid>
        </Grid>
        <br />
        <br />
        <br />
        <br />
      </Container>

      <Contact />
    </>
  );
};

export default Start;
